import Block from './Block.vue';

export * from './components';
export default Block;



// WEBPACK FOOTER //
// ./src/pages/profile/components/info/components/block/index.ts